<template>
  <MainTab
    :main-title="mainTitle"
    :confirm-button-text="mainActionCTA"
    :action="mainAction"
    :condition="areLabsOrPlenarySelected"
  >
    <ContentWrapper>
      <template #default>
        <LabsChoice
          v-if="!labSavedMessage"
          :sessions="sessions"
          :select-lab-action="setActiveLaboratory"
          :first-empty-session="firstEmptySession"
        ></LabsChoice>
        <div v-else class="dea-heading--regular__ms">{{ labSavedMessage }}</div>
      </template>
    </ContentWrapper>
  </MainTab>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import LabsChoice from "~/components/events/components/LabsChoice";
import MainTab from "~/components/events/components/MainTab";

export default {
  name: "EventsEditLaboratories",
  components: {
    MainTab,
    ContentWrapper,
    LabsChoice,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["sessions", "firstEmptySession", "labSavedMessage"]),
    areLabsOrPlenarySelected() {
      if (this.firstEmptySession === null || this.voidLabsChecked) {
        return true;
      }
      return false;
    },
    mainActionCTA() {
      if (this.labSavedMessage) {
        return "Indietro";
      }
      return "Salva modifiche";
    },
    mainAction() {
      if (this.labSavedMessage) {
        return this.back;
      }
      return this.storeAndSuccessRegistrationLabs;
    },
  },
  mounted() {
    this.fetchRegistration({ registrationId: this.$route.params.registration, force: false });
    this.setLabSavedMessage("");
  },
  methods: {
    ...mapActions([
      "getNextActiveRegistration",
      "setActiveLaboratory",
      "storeAndSuccessRegistrationLabs",
      "fetchRegistration",
    ]),
    ...mapMutations(["setLabSavedMessage"]),
    back() {
      this.$router.push({ name: "eventi" });
      this.setLabSavedMessage("");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.dea-card-resource__button {
  align-items: center;
  background: none;
  border: $border-bold $dea-color-grey-dark;
  border-radius: $border-radius-circle;
  display: flex;
  height: $dea-size-large;
  justify-content: center;
  margin-left: $space-x-small;
  padding: 0;
  width: $dea-size-large;

  &:before {
    font-size: $dea-size-medium;
  }

  @include bp-large-max {
    display: none;
    height: 32px;
    margin-left: $space-xx-small;
    width: 32px;

    &:before {
      font-size: $dea-size-small;
    }
  }
}
</style>
